import axios from 'axios';

export interface DeleteExtractionDataResponse {
  success: boolean;
  message: string;
  data: { tasksDeleted: number };
}

export interface DeleteAccountResponse {
  success: boolean;
  message: string;
}

/**
 * Delete all extraction data for the current user
 * @param confirm - Confirmation flag (must be true)
 * @returns Promise with deletion response
 */
export const deleteExtractionDataApi = async (
  confirm: boolean,
): Promise<DeleteExtractionDataResponse> => {
  const response = await axios.delete<DeleteExtractionDataResponse>(
    '/api/user/delete-extraction-data',
    {
      data: { confirm },
    },
  );
  return response.data;
};

/**
 * Delete user account
 * @param password - User's password for verification
 * @param confirm - Confirmation flag (must be true)
 * @returns Promise with deletion response
 */
export const deleteAccountApi = async (
  password: string,
  confirm: boolean,
): Promise<DeleteAccountResponse> => {
  const response = await axios.delete<DeleteAccountResponse>(
    '/api/user/delete-account',
    {
      data: { password, confirm },
    },
  );
  return response.data;
};
